import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { uniqueId } from "lodash";

/**
 * @description 给菜单数据补充上 path 字段
 * @description https://github.com/d2-projects/d2-admin/issues/209
 * @param {Array} menu 原始的菜单数据
 */
function supplementPath(menu) {
  return menu.map(function (e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      path: e.path || uniqueId("d2-menu-empty-")
    }, e.children ? {
      children: supplementPath(e.children)
    } : {});
  });
}
export var menuHeader = supplementPath([
  // { path: "/index", title: "首页", icon: "home" },
  // {
  //     title: "页面",
  //     icon: "folder-o",
  //     children: [
  //         { path: "/page1", title: "页面 1" },
  //         { path: "/page2", title: "页面 2" },
  //         { path: "/page3", title: "页面 3" }
  //     ]
  // }
]);
export var menuAside = supplementPath([{
  path: "/index",
  title: "首页",
  icon: "home"
}, {
  title: "基本信息",
  icon: "th-large",
  children: [{
    path: "/base/city",
    title: "城市管理"
  }, {
    path: "/base/renting/type",
    title: "租房类型"
  }, {
    path: "/base/time/type",
    title: "时间类型"
  }, {
    path: "/base/house/facilities",
    title: "房源设施"
  }, {
    path: "/base/tags",
    title: "标签管理"
  }, {
    path: "/base/phone/code",
    title: "电话代码"
  }, {
    path: "/base/app/version",
    title: "版本管理"
  }, {
    path: "/base/social",
    title: "社交媒体"
  }, {
    path: "/base/sms",
    title: "短信极速通知"
  }, {
    path: "/base/unit/currency",
    title: "货币单位"
  }, {
    path: "/base/unit/area",
    title: "面积单位"
  }, {
    path: "/base/slogan",
    title: "Slogan"
  }, {
    path: "/base/boot-screen",
    title: "开机屏"
  }
  // { path: "/base/summary", title: "总结评分" }
  // { path: "/base/business-contact-config", title: "商务配置" },
  // { path: "/base/business-contact", title: "商务联系人" },
  // { path: "/base/menu", title: "菜单管理" },
  // { path: "/base/operation/log", title: "操作日志" },
  ]
}, {
  title: "运营管理",
  icon: "flag",
  children: [{
    path: "/user/manager",
    title: "管理员列表"
  }, {
    path: "/base/business-contact-config",
    title: "商务配置"
  }, {
    path: "/base/business-contact",
    title: "商务联系人"
  }, {
    path: "/base/business/cooperation",
    title: "商务合作"
  }, {
    path: "/base/menu",
    title: "菜单管理"
  }, {
    path: "/base/operation/log",
    title: "操作日志"
  }]
}, {
  title: "线上签约",
  icon: "credit-card",
  children: [{
    path: "/capital/sign",
    title: "签约记录"
  }, {
    path: "/capital/dispute",
    title: "纠纷处理"
  }, {
    path: "/capital/withdraw",
    title: "提现申请"
  }, {
    path: "/capital/list",
    title: "用户流水"
  }, {
    path: "/capital/rate",
    title: "汇率管理"
  }]
}, {
  title: "订单管理",
  icon: "list-alt",
  children: [{
    path: "/order/domestic/sign",
    title: "线上签约"
  }, {
    path: "/order/domestic/contract",
    title: "国内签约（旧版）"
  }, {
    path: "/order/foreign/contract",
    title: "跨境签约（旧版）"
  }, {
    path: "/order/housing/certification",
    title: "房源认证"
  }, {
    path: "/order/housing/promotion",
    title: "房源推广"
  }, {
    path: "/order/sms",
    title: "短信极速通知"
  }, {
    path: "/order/brand",
    title: "品牌充值"
  }, {
    path: "/order/real-name",
    title: "实名认证"
  }, {
    path: "/order/tickets",
    title: "门票"
  }, {
    path: "/order/refund",
    title: "退款管理"
  }, {
    path: "/order/member",
    title: "会员充值"
  }, {
    path: "/order/forceRealName",
    title: "强制实名"
  }]
}, {
  title: "品牌充值",
  icon: "diamond",
  children: [{
    path: "/brand/user",
    title: "充值用户"
  }, {
    path: "/brand/apartment",
    title: "充值房源"
  }, {
    path: "/brand/apartment/audit",
    title: "充值审核"
  }, {
    path: "/brand/account/detail",
    title: "账户详情"
  }, {
    path: "/brand/settlement",
    title: "结算记录"
  }, {
    path: "/brand/money",
    title: "资金记录"
  }, {
    path: "/brand/income",
    title: "收入统计"
  }]
},
// {
//     title: "民宿管理",
//     icon: "hotel",
//     children: [
//         { path: "/bnb/user", title: "民宿用户" },
//         { path: "/bnb/apartment", title: "民宿房源" },
//         { path: "/bnb/apartment/audit", title: "民宿审核" },
//         { path: "/bnb/account/detail", title: "账户详情" },
//         { path: "/bnb/settlement", title: "结算记录" },
//         { path: "/bnb/money", title: "资金记录" },
//         { path: "/bnb/income", title: "收入统计" }
//     ]
// },

{
  title: "品牌季度",
  icon: "star",
  children: [
  // { path: "/quarter/user", title: "季度用户" },
  {
    path: "/quarter/userNew",
    title: "季度用户"
  }, {
    path: "/quarter/house",
    title: "季度房源"
  },
  // { path: "/quarter/apartment", title: "季度公寓" },
  {
    path: "/quarter/apartment/audit",
    title: "季度审核"
  }, {
    path: "/quarter/company",
    title: "公司名单"
  }, {
    path: "/quarter/orderRecord",
    title: "订单记录"
  }, {
    path: "/quarter/deposit",
    title: "押金订单"
  }, {
    path: "/quarter/paymentRecord",
    title: "收款记录"
  }, {
    path: "/quarter/statistics",
    title: "周报"
  }, {
    path: "/signing/list",
    title: "合同管理"
  }]
}, {
  title: "房源管理",
  icon: "home",
  children: [{
    path: "/house/list",
    title: "房源列表"
  }, {
    path: "/house/audit",
    title: "房源审核"
  }, {
    path: "/house/real-name",
    title: "实名认证"
  }, {
    path: "/house/auth",
    title: "认证列表"
  }, {
    path: "/house/deleted",
    title: "已删房源"
  }, {
    path: "/house/sign-contract",
    title: "签约管理"
  }]
}, {
  title: "房源推广",
  icon: "bullhorn",
  children: [
  // { path: "/promote/config", title: "推广配置(旧版)" },
  {
    path: "/promote/config/v2",
    title: "推广配置"
  },
  // { path: "/promote/list", title: "推广列表(旧版)" },
  {
    path: "/promote/list/v2",
    title: "推广列表"
  }
  // { path: "/house/vip/list", title: "品牌公寓" }
  ]
}, {
  title: "优惠券管理",
  icon: "ticket",
  children: [{
    path: "/coupon/config",
    title: "配置列表"
  }, {
    path: "/coupon/record",
    title: "发放明细"
  }]
}, {
  title: "置顶池",
  icon: "arrow-up",
  children: [{
    path: "/top/config",
    title: "置顶池管理"
  }, {
    path: "/top/list/quarter/1",
    title: "季度置顶池"
  }, {
    path: "/top/list/brand/2",
    title: "充值置顶池"
  }, {
    path: "/top/list/member/3",
    title: "会员置顶池"
  }, {
    path: "/top/list/choiceness/4",
    title: "精选房源置顶池"
  }, {
    path: "/top/record",
    title: "置顶记录"
  }]
}, {
  title: "社区管理",
  icon: "users",
  children: [{
    path: "/community/list",
    title: "社区列表"
  }, {
    path: "/community/audit",
    title: "社区审核"
  }, {
    path: "/community/comment",
    title: "评论审核"
  }, {
    path: "/community/tag",
    title: "标签管理"
  }, {
    path: "/community/category",
    title: "分类管理"
  }, {
    path: "/community/simulationList",
    title: "模拟推荐"
  }]
}, {
  title: "Lifestyle",
  icon: "soccer-ball-o",
  children: [{
    path: "/lifestyle/list",
    title: "Lifestyle列表"
  }, {
    path: "/lifestyle/audit",
    title: "审核列表"
  }, {
    path: "/lifestyle/recommend",
    title: "推荐列表"
  }, {
    path: "/lifestyle/draft",
    title: "草稿列表"
  }, {
    path: "/lifestyle/tag",
    title: "标签管理"
  }, {
    path: "/comment/audit/lifestyle",
    title: "评论审核"
  }, {
    path: "/lifestyle/activeConfig",
    title: "活动配置"
  }]
}, {
  title: "唯心市集",
  icon: "shopping-cart",
  children: [{
    path: "/used/audit",
    title: "审核列表"
  }, {
    path: "/comment/audit/used",
    title: "评论列表"
  }, {
    path: "/used/ads",
    title: "广告位"
  }, {
    path: "/used/recommend",
    title: "推荐列表"
  }, {
    path: "/used/list",
    title: "物品列表"
  }, {
    path: "/used/category",
    title: "分类列表"
  }
  // { path: "/used/draft", title: "草稿列表" },
  ]
}, {
  title: "Banner管理",
  icon: "photo",
  children: [{
    path: "/banner/pc",
    title: "PC端"
  }, {
    path: "/banner/mobile",
    title: "移动端"
  }]
}, {
  title: "活动故事",
  icon: "file-text",
  children: [{
    path: "/article/category",
    title: "文章分类"
  }, {
    path: "/article/story",
    title: "故事管理"
  }, {
    path: "/article/activity",
    title: "体验管理"
  }, {
    path: "/article/company",
    title: "公司信息"
  }, {
    path: "/comment/audit/article",
    title: "评论审核"
  }]
}, {
  title: "用户管理",
  icon: "user",
  children: [
  // { path: "/user/manager", title: "管理员列表" },
  {
    path: "/user/list",
    title: "用户列表"
  }, {
    path: "/user/member",
    title: "会员列表"
  }, {
    path: "/user/city-master",
    title: "城市大使"
  }, {
    path: "/user/city-master/settlement-rules",
    title: "结算规则",
    hide: true,
    level: ["用户管理", "城市大使", "结算规则"]
  }, {
    path: "/user/city-master/settlement",
    title: "结算历史",
    hide: true,
    level: ["用户管理", "城市大使", "结算历史"]
  }, {
    path: "/user/city-master/invitation-log",
    title: "邀请记录",
    hide: true,
    level: ["用户管理", "城市大使", "邀请记录"]
  }, {
    path: "/user/auth-landlord",
    title: "认证房东"
  }, {
    path: "/user/real-name",
    title: "实名列表"
  }, {
    path: "/user/force-real-name",
    title: "强制实名"
  },
  // { path: "/user/observed", title: "待观察用户" },
  {
    path: "/user/deviceId",
    title: "设备ID"
  }, {
    path: "/user/ip/log",
    title: "IP记录"
  }, {
    path: "/user/phone-update-record",
    title: "换绑记录"
  }, {
    path: "/user/logout",
    title: "账号注销"
  }]
}, {
  title: "客户咨询",
  icon: "twitch",
  children: [{
    path: "/consult/list",
    title: "咨询列表"
  }, {
    path: "/consult/classify",
    title: "咨询分类"
  }, {
    path: "/consult/commonProblem",
    title: "常见问题"
  }, {
    path: "/consult/commonProblemSub",
    title: "常见问题",
    hide: true
  }]
}, {
  title: "IM管理",
  icon: "comments",
  children: [{
    path: "/im/list",
    title: "IM聊天"
  }, {
    path: "/im/search",
    title: "IM搜索"
  }, {
    path: "/im/monitor",
    title: "IM监测"
  }, {
    path: "/im/group-send/message",
    title: "群发消息"
  }]
}, {
  title: "投诉管理",
  icon: "warning",
  children: [{
    path: "/complaint/type",
    title: "投诉分类"
  }, {
    path: "/complaint/list",
    title: "投诉列表"
  }, {
    path: "/complaint/quickList",
    title: "一键投诉"
  }, {
    path: "/complaint/feedback",
    title: "意见反馈"
  }]
}, {
  title: "数据统计",
  icon: "database",
  children: [{
    path: "https://web.umeng.com/main.php?c=site&a=show",
    title: "友盟PC"
  }, {
    path: "https://mobile.umeng.com/apps",
    title: "友盟App"
  }, {
    path: "http://superset.wellcee.com/superset/welcome",
    title: "Superset"
  }, {
    path: "https://www.wellcee.com/padmin/?page=1",
    title: "后台V2"
  }, {
    path: "/statistics/assist",
    title: "好友助力"
  }]
}]);